// extracted by mini-css-extract-plugin
export default {"scrollContainer":"CardPreview_scrollContainer__cT28c"};